import React, { useContext, useState } from "react";
import "../../../assets/css/user/contactPage/ContactPage.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const ContactPage = () => {
  const { baseUrl } = useContext(AppContext);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [sending, setSending] = useState(false);

  // ==========================
  // Handle Input Change
  // ==========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ==========================
  // Submit Contact Message
  // ==========================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (sending) return;

    setSending(true);

    try {
      const response = await axios.post(
        `${baseUrl}/customer/contact/sendMessage`,
        formData
      );

      console.log("Contact Response:", response.data);

      if (response.data.success) {
        alert("Message sent successfully!");

        // Clear form
        setFormData({
          fullName: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        alert(
          response.data.message || "Unable to send your message."
        );
      }
    } catch (error) {
      console.log("CONTACT ERROR:", error);

      alert(
        error.response?.data?.message ||
          "Something went wrong while sending your message."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="cp-wrapper">
      <div className="cp-container">

        {/* =========================
            Left Section
        ========================== */}
        <div className="cp-info">
          <h1 className="cp-title">Get in Touch</h1>

          <p className="cp-subtitle">
            Have questions? We'd love to hear from you!
          </p>

          <div className="cp-info-list">

            {/* Email */}
            <div className="cp-info-item">
              <div className="cp-info-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>

              <div className="cp-info-text">
                <span className="cp-info-label">Email</span>
                <span className="cp-info-value">
                  support@time4pulse.com
                </span>
              </div>
            </div>

            {/* Phone */}
            <div className="cp-info-item">
              <div className="cp-info-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>

              <div className="cp-info-text">
                <span className="cp-info-label">Phone</span>
                <span className="cp-info-value">
                  +92 300 1234567
                </span>
              </div>
            </div>

            {/* Address */}
            <div className="cp-info-item">
              <div className="cp-info-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>

              <div className="cp-info-text">
                <span className="cp-info-label">Address</span>
                <span className="cp-info-value">
                  Lahore, Pakistan
                </span>
              </div>
            </div>

          </div>
        </div>

        {/* =========================
            Right Section - Form
        ========================== */}
        <div className="cp-form-card">

          <form onSubmit={handleSubmit}>

            <div className="cp-form-row">

              {/* Full Name */}
              <div className="cp-form-group">
                <label className="cp-form-label">
                  Full Name
                </label>

                <input
                  type="text"
                  name="fullName"
                  className="cp-form-input"
                  placeholder="Your name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="cp-form-group">
                <label className="cp-form-label">
                  Email
                </label>

                <input
                  type="email"
                  name="email"
                  className="cp-form-input"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

            </div>

            {/* Subject */}
            <div className="cp-form-group">
              <label className="cp-form-label">
                Subject
              </label>

              <input
                type="text"
                name="subject"
                className="cp-form-input"
                placeholder="How can we help?"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            {/* Message */}
            <div className="cp-form-group">
              <label className="cp-form-label">
                Message
              </label>

              <textarea
                name="message"
                className="cp-form-textarea"
                placeholder="Write your message..."
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="cp-submit-btn"
              disabled={sending}
            >
              {sending ? (
                <>
                  <span className="cp-send-icon">
                    ⏳
                  </span>
                  Sending...
                </>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="cp-send-icon"
                  >
                    <line x1="22" y1="2" x2="11" y2="13" />
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>

                  Send Message
                </>
              )}
            </button>

          </form>
        </div>

      </div>
    </div>
  );
};

export default ContactPage;